import React from 'react';
import './index.less';

const TextWithHighlight = () => {
  return (
    <div className="text-with-highlight">
      <div className="content-max">
        <p className="text">
          A single platform that provides you the tools and resources to save your brand{' '}
          <span className="highlight">time and money.</span>
        </p>
      </div>
    </div>
  );
};

export default TextWithHighlight;
